/* Opening intro, modelled on the anacuna.com load sequence:
   1. an opaque sheet covers the whole page, header included — nothing shows
      behind it
   2. once the page has finished loading, a hairline sweeps left-to-right across
      the sheet, then retracts to the right edge
   3. the sheet is removed and the page arrives: the wordmark drops into the
      header on an elastic ease, the nav items follow on the same ease one
      stagger step behind, and the work rows climb up from below the fold in a
      tight overlapping cascade

   Timings live in CSS custom properties (see "Opening Intro" in screen.css).
   Gating happens pre-paint in default.hbs, which adds .is-intro to <html>. */
function intro() {
    var root = document.documentElement;
    if (!root.classList.contains('is-intro')) return;

    var feed = document.querySelector('.gh-work-feed[data-work-feed]');
    var rows = feed
        ? Array.prototype.slice.call(feed.querySelectorAll('[data-work-row]'))
        : [];

    rows.forEach(function (row, i) {
        row.style.setProperty('--intro-row-index', i);
    });

    var items = Array.prototype.slice.call(
        document.querySelectorAll('.gh-navigation-menu .gh-localized-links > li')
    );

    items.forEach(function (item, i) {
        item.style.setProperty('--intro-item-index', i);
    });

    var overlay = document.createElement('div');
    overlay.className = 'gh-intro';
    overlay.setAttribute('aria-hidden', 'true');

    var line = document.createElement('span');
    line.className = 'gh-intro-line';
    overlay.appendChild(line);
    document.body.appendChild(overlay);

    var revealRows = function () {
        if (!feed || !rows.length) return;

        // Rows start a full feed-height below their resting position, so the
        // height has to be read while they are still laid out normally.
        feed.style.setProperty('--intro-feed-height', feed.offsetHeight + 'px');
        root.classList.add('is-intro-rows');

        rows[rows.length - 1].addEventListener('animationend', function () {
            // Hand transform back to the hover lift once the cascade has landed.
            root.classList.remove('is-intro-rows');
            rows.forEach(function (row) {
                row.style.removeProperty('--intro-row-index');
            });
        }, {once: true});
    };

    var revealMenu = function () {
        root.classList.add('is-intro-menu');
        if (!items.length) return;

        // Same handback as the rows: the slot the wordmark and the items drop
        // out of is a mask, and a mask is only wanted while something is
        // dropping. The last item carries the longest delay, so it lands last.
        items[items.length - 1].addEventListener('animationend', function () {
            root.classList.remove('is-intro-menu');
            items.forEach(function (item) {
                item.style.removeProperty('--intro-item-index');
            });
        }, {once: true});
    };

    var finished = false;
    var finish = function () {
        if (finished) return;
        finished = true;

        overlay.remove();
        root.classList.remove('is-intro', 'is-intro-wipe');
        revealMenu();
        revealRows();
    };

    var sweep = function () {
        line.addEventListener('animationend', finish, {once: true});
        root.classList.add('is-intro-wipe');
    };

    /* The sweep waits for load, as on the reference site, so slow assets do not
       land mid-animation. */
    if (document.readyState === 'complete') {
        sweep();
    } else {
        window.addEventListener('load', sweep, {once: true});
    }

    // Never leave the page stranded behind the sheet if an animation never fires.
    setTimeout(finish, 12000);
}
